import { getPagosDeuda } from "./finanzasDeuda";
import { safeMoneyNumber } from "./contextoFinanciero";

const normalize = (value = "") =>
  String(value || "").trim().toLowerCase();

const truthy = (value) => value === true || value === "true" || value === 1;

export const getPropiedadIdsDeuda = (deuda = {}) => {
  if (Array.isArray(deuda.propiedadIds) && deuda.propiedadIds.length) {
    return deuda.propiedadIds.filter(Boolean);
  }
  if (Array.isArray(deuda.propiedadesIds) && deuda.propiedadesIds.length) {
    return deuda.propiedadesIds.filter(Boolean);
  }
  if (Array.isArray(deuda.propiedades) && deuda.propiedades.length) {
    return deuda.propiedades
      .map((item) => item?.propiedadId || item?.id)
      .filter(Boolean);
  }
  return deuda.propiedadId ? [deuda.propiedadId] : [];
};

export const deudaPerteneceAPropiedad = (deuda = {}, propiedadId = "") =>
  Boolean(propiedadId && getPropiedadIdsDeuda(deuda).includes(propiedadId));

export const esPropiedadDeSocio = (propiedad = {}) => {
  const estado = normalize(propiedad.estado);
  const propietarioTipo = normalize(
    propiedad.propietarioTipo ||
      propiedad.tipoPropietario ||
      propiedad.origenPropiedad ||
      propiedad.tipoOrigen
  );

  return Boolean(
    propiedad.socioId ||
      propiedad.socioNombre ||
      truthy(propiedad.apartadaSocio) ||
      estado === "apartada_socio" ||
      propietarioTipo === "socio" ||
      propietarioTipo === "tercero"
  );
};

export const generaUtilidadKye = (propiedad = {}) => {
  if (typeof propiedad.generaUtilidadKye === "boolean") {
    return propiedad.generaUtilidadKye;
  }
  if (typeof propiedad.generaUtilidad === "boolean") {
    return propiedad.generaUtilidad;
  }
  return !esPropiedadDeSocio(propiedad);
};

export const participaInventarioKye = (propiedad = {}) => {
  if (typeof propiedad.participaInventarioKye === "boolean") {
    return propiedad.participaInventarioKye;
  }
  if (typeof propiedad.inventarioKye === "boolean") {
    return propiedad.inventarioKye;
  }
  return !esPropiedadDeSocio(propiedad);
};

export const getPrecioPropiedad = (propiedad = {}) =>
  safeMoneyNumber(
    propiedad.precioVenta ??
      propiedad.precioFinanciado ??
      propiedad.precioContado ??
      propiedad.precio
  );

export const getPrecioContadoPropiedad = (propiedad = {}) =>
  safeMoneyNumber(propiedad.precioContado ?? propiedad.precio ?? 0);

export const esPropiedadVendida = (propiedad = {}) => {
  const estado = normalize(propiedad.estado);
  return Boolean(
    estado === "vendida" ||
      estado === "vendido" ||
      truthy(propiedad.vendida) ||
      truthy(propiedad.asociadaADeuda) ||
      (propiedad.disponible === false && Boolean(propiedad.deudaId))
  );
};

export const getFactorDeudaParaPropiedad = (deuda = {}, propiedad = {}, propiedades = []) => {
  const propiedadId = propiedad.id;
  const ids = getPropiedadIdsDeuda(deuda);
  if (!propiedadId || !ids.includes(propiedadId)) return 0;
  if (ids.length <= 1) return 1;

  return 1 / ids.length;
};

export const distribuirDeudaParaPropiedad = (deuda = {}, propiedad = {}, propiedades = []) => {
  const factor = getFactorDeudaParaPropiedad(deuda, propiedad, propiedades);
  if (factor <= 0) return null;

  const pagos = getPagosDeuda(deuda).map((pago) => ({
    ...pago,
    cantidad: safeMoneyNumber(pago?.cantidad) * factor,
    cantidadOriginal: pago?.cantidad,
    factorDistribucion: factor,
  }));

  const monto = safeMoneyNumber(deuda.monto ?? deuda.importe) * factor;
  const saldoRestante = safeMoneyNumber(deuda.saldoRestante ?? deuda.saldo) * factor;

  return {
    ...deuda,
    monto,
    importe: monto,
    saldoRestante,
    saldo: saldoRestante,
    pagos,
    montoOriginalContrato: deuda.monto ?? deuda.importe ?? 0,
    saldoOriginalContrato: deuda.saldoRestante ?? deuda.saldo ?? 0,
    factorDistribucion: factor,
    contratoMultipropiedad: getPropiedadIdsDeuda(deuda).length > 1,
  };
};

export const distribuirDeudasParaPropiedad = (deudas = [], propiedad = {}, propiedades = []) =>
  deudas
    .map((deuda) => distribuirDeudaParaPropiedad(deuda, propiedad, propiedades))
    .filter(Boolean);
